import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';
import type { IShipmentData, ITrackingEventDateOptions } from '@/modules/pmt/interfaces';
import { trackingEventDateModify } from '@/modules/pmt/utils';
import { DetailLeftContainer, SubTitle, Time, Title } from '../../TrackingEventCardHeader.styles';

const parcelDateFormatOptions: ITrackingEventDateOptions = {
  showDate: true,
  showTime: true,
  fullDay: false,
  showDay: true,
  isFormatTimeUnderOneDay: true,
};

export interface ITrackingEventPendingProps {
  trackingDetails?: IShipmentData;
}

const TrackingEventPending = ({ trackingDetails }: ITrackingEventPendingProps) => {
  const { t } = useGlobalState();
  const { get, isReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const shipmentImportedDate = trackingDetails?.shipmentImportedDate ?? new Date().toISOString();
  const waitingTrackingInfo = isReady
    ? get('waiting_tracking_info', t(MasterTranslation.WaitingTrackingInfo))
    : t(MasterTranslation.WaitingTrackingInfo);

  return (
    <DetailLeftContainer>
      <Time>{trackingEventDateModify(shipmentImportedDate, parcelDateFormatOptions, t)}</Time>
      <Title>{t(MasterTranslation.ToShip)}</Title>
      <SubTitle>{waitingTrackingInfo}</SubTitle>
    </DetailLeftContainer>
  );
};

export { TrackingEventPending };
